import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { Button, Form } from 'react-bootstrap';
import Select from 'react-select';
import { getRequest } from '../../helpers/apiHandler';

const CreditCalculator = () => {
  const { access_token } = useSelector((state) => state.auth.user)
  const [priceData, setPriceData] = useState([]);
  const [destination, setDestination] = useState();
  const [selectedCurrency, setSelectedCurrency] = useState();
  const [messages, setMessages] = useState(0);
  const [costPerSms, setCostPerSms] = useState(0);
  const [totalCost, setTotalCost] = useState(0);
  const [selectedPricing, setSelectedPricing] = useState({});
  const [destinationError, setDestinationError] = useState({ error: false, message: '' });
  const [currencyError, setCurrencyError] = useState({ error: false, message: '' });

  const currencies = [
    { value: 'myr', label: 'RM', symbol: 'RM' },
    { value: 'eur', label: 'EUR', symbol: '€' },
    { value: 'usd', label: 'USD', symbol: '$' },
  ];

  const handleDestinationChanged = (e) => {
    const countryCode = e.value;
    const pricingData = priceData.find((e) => e.country === countryCode);

    setDestination(countryCode);
    setSelectedPricing(pricingData);
    if (destinationError.error) {
      setDestinationError({ error: false, message: '' });
    }
  };

  const handleCurrencyChanged = (e) => {
    setSelectedCurrency(e);
    if (currencyError.error) {
      setCurrencyError({ error: false, message: '' });
    }
  };

  const handleMessagesChanged = (e) => {
    const positiveValue = Math.abs(Number(e.target.value));
    setMessages(positiveValue);
    e.target.value = positiveValue;
  };

  const handleCalculate = () => {
    if (!destination) {
      setDestinationError({ error: true, message: 'Please select destination country.' })
      return;
    }
    if (!selectedCurrency) {
      setCurrencyError({ error: true, message: 'Please select currency.' })
      return;
    }
    const countryCode = selectedCurrency?.value;
    const cost = selectedPricing[countryCode];
    const tCost = (cost * messages).toFixed(2);
    setCostPerSms(cost);
    setTotalCost(tCost);
  };

  useEffect(() => {
    const data = { headers: { Authorization: access_token.token } };
    getRequest('/payment/sms-price-list', data, (res) => {
      if (res.success) {
        const result = res.data;
        setPriceData(result);
      }
    });
  }, []);

  return (
    <Form className="credit-calculator-form">
      <Form.Group>
        <Form.Label>Messages</Form.Label>
        <Form.Control placeholder="Enter Amount" type="number" onChange={handleMessagesChanged} />
      </Form.Group>
      <Form.Group>
        <Form.Label>Destination Country</Form.Label>
        <Select
          options={priceData.map((c) => ({ value: c.country, label: c.name }))}
          onChange={handleDestinationChanged}
        />
        {destinationError.error && <span style={{ fontSize: 11, color: 'red' }}>{destinationError.message}</span>}
      </Form.Group>
      <Form.Group>
        <Form.Label>Currency</Form.Label>
        <Select
          options={currencies}
          onChange={handleCurrencyChanged}
        />
        {currencyError.error && <span style={{ fontSize: 11, color: 'red' }}>{currencyError.message}</span>}
      </Form.Group>
      <Form.Group>
        <Form.Label className="d-none d-sm-block">&nbsp;</Form.Label>
        <Button variant="ghost" onClick={handleCalculate}>
          Calculate
        </Button>
      </Form.Group>
      <Form.Group>
        <Form.Label className="credit-calculated-label">Cost per SMS</Form.Label>
        <h2 className="credit-calculated-value">
          {selectedCurrency?.symbol} {costPerSms}
        </h2>
      </Form.Group>
      <Form.Group>
        <Form.Label className="credit-calculated-label">Total Estimated Cost</Form.Label>
        <h2 className="credit-calculated-value">
          {selectedCurrency?.symbol} {totalCost}
        </h2>
      </Form.Group>
    </Form>
  );
};

export default CreditCalculator;
